import React, { Component } from 'react';
import './App.css';

import Home  from './Home';
import MainLayout from './MainLayout';
import { Router, Route, IndexRoute, browserHistory } from 'react-router';
import NoMatch from './NoMatch';
import Info from './Info';

import PriceCalculator from './PriceCalculator';


import {createStore, combineReducers, applyMiddleware} from 'redux';
import {Provider} from 'react-redux';
import {pricesReducer} from '../reducers/PriceCalculator';
import {footprintReducer} from '../reducers/Footprints';
import {syncHistoryWithStore, routerMiddleware, routerReducer} from 'react-router-redux';
import createLogger from 'redux-logger';
import thunkMiddleware from 'redux-thunk';


const loggerMiddleware = createLogger();

const store = createStore(combineReducers({
  pricesReducer,
  routing: routerReducer,
  footprints: footprintReducer,
}),
  applyMiddleware(
    routerMiddleware(browserHistory),
    thunkMiddleware,
    loggerMiddleware,
  )
);

const history = syncHistoryWithStore(browserHistory, store);

class App extends Component {
  render() {
    return (
    <Provider store={store}>
      <Router history={history}>
        <Route path="/" component={MainLayout}>
          <IndexRoute component={Home}/>
          {/* <LoginRoute path='/login' component={LoginPage} /> */}
 
          <Route path="/calculator" component={PriceCalculator} />
          <Route path="/calculator/:network_name" component={PriceCalculator} />
          <Route path="/site/:siteId" component={Info} />
          <Route path="/site/:siteId/:subView" component={Info} />
          <Route path="*" component={NoMatch}/>
        </Route>
      </Router>
    </Provider>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/views/App.js